// Shared calendar boundaries for game views and server-side tips periods.
export const dateKey = (date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(date.getDate()).padStart(2, "0")}`;
export function calendarDate(key) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(key || "")) return null;
  const [y, m, d] = key.split("-").map(Number),
    date = new Date(y, m - 1, d, 12);
  return dateKey(date) === key ? date : null;
}
export function berlinDay(value = new Date()) {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/Berlin",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(value);
  const part = (type) => parts.find((p) => p.type === type).value;
  return `${part("year")}-${part("month")}-${part("day")}`;
}
export const today = () => calendarDate(berlinDay());
export function addDays(date, count) {
  const d = new Date(date);
  d.setDate(d.getDate() + count);
  return d;
}
function isoWeek(date) {
  const d = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
  );
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  return {
    year: d.getUTCFullYear(),
    week: Math.ceil(
      ((d - new Date(Date.UTC(d.getUTCFullYear(), 0, 1))) / 86400000 + 1) / 7
    ),
  };
}
export function weekSection(date = today()) {
  const day = date.getDay(),
    a = day >= 2 && day <= 4;
  const start = addDays(date, a ? 2 - day : -((day + 2) % 7));
  return {
    start,
    end: addDays(start, a ? 2 : 3),
    section: a ? "A" : "B",
    ...isoWeek(start),
  };
}
export function adjacentSection(range, direction) {
  return weekSection(
    addDays(direction < 0 ? range.start : range.end, direction < 0 ? -1 : 1)
  );
}
